<template>
  <!-- 配置模板 -->
  <a-breadcrumb>
    <a-breadcrumb-item>配置管理</a-breadcrumb-item>
    <a-breadcrumb-item>{{ props.name }}</a-breadcrumb-item>
  </a-breadcrumb>
  <div class="content">
    <div class="action">
      <a-checkbox v-model:checked="checked" @change="changeChecked">隐藏停用{{ props.shortName }}</a-checkbox>
      <a-button type="primary" @click="add"><plus-outlined />新增{{ props.shortName }}</a-button>
    </div>
    <div class="table-box">
      <a-table
        :data-source="dataSource"
        :columns="columns"
        :pagination="pagination"
        :row-key="record => record.id"
        :loading="isLoading"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record }">
          <!-- 操作 -->
          <template v-if="column.key === 'operation'">
            <a class="operation-item" @click="edit(record)">编辑</a>
            <a class="operation-item" @click="move(record, 'up')">上移</a>
            <a class="operation-item" @click="move(record, 'down')">下移</a>
            <a class="operation-item" @click="stop(record)" v-if="record.status === 1">停用</a>
            <a class="operation-item" @click="stop(record)" v-else style="color: #A3ACB3;">开启</a>
          </template>
        </template>
      </a-table>
    </div>
  </div>
  <!-- 新增、编辑弹窗 -->
  <Add ref="RefAdd" :source="source" @success="getList" />
</template>

<script setup>
import { ref, reactive, nextTick, onBeforeMount } from 'vue'
import { message } from 'ant-design-vue'
import { ClassifySettings } from '@/utils/constantList'
import Add from './Add.vue'
import { getAllClassifyList, allClassifySort, allClassifySwitch } from '@/api/admin'

// props（source：请同步维护 constantList 文件中 ClassifySettings 字段）
const props = defineProps({
  name: String,
  shortName: String,
  source: String
})
// 配置类型
const source = ClassifySettings[props.source]

// 单个子组件暴露体初始化
let RefAdd = ref(null)
// 是否隐藏停用类型
let checked = ref(true)
// 数据源
let dataSource = ref(null)
// 加载
let isLoading = ref(false)
// 表头
let columns = reactive([
  {
    title: '顺序',
    dataIndex: 'sord_id',
    key: 'sord_id',
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: props.name,
    dataIndex: 'name',
    key: 'name',
    width: 500
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 名称编辑中
let isEdit = ref(false)
// 编辑中的数据
let editData = ref({})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  getList()
})

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 切换隐藏状态
function changeChecked () {
  pagination.current = 1
  // 获取列表
  getList()
}

// 请求分页数据
function getList () {
  isLoading.value = true
  const params = {
    source,
    status: checked.value ? 1 : 0,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  getAllClassifyList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.list
      pagination.total = data.paginate.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 子组件新增弹窗
function add () {
  RefAdd.value.showDrawer()
}

// 编辑
function edit (record) {
  RefAdd.value.showDrawer(record)
}

// 上移、下移
function move (record, type) {
  isLoading.value = true
  allClassifySort({
    source,
    type,
    id: record.id
  }).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

// 开启停用
function stop (record) {
  isLoading.value = true
  allClassifySwitch({
    source,
    type: record.status === 1 ? 0 : 1,
    id: record.id
  }).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

</script>

<style lang="less" scoped>
.content {
  padding: 24px 0;
  .action {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .operation-item {
    margin-right: 8px;
  }
}

</style>